"use strict";

var _classCallCheck = require("/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shape = void 0;

var Enums_1 = require("../../../../Enums");

var Utils_1 = require("../../../../Utils");

var Shape = /*#__PURE__*/function () {
  function Shape() {
    _classCallCheck(this, Shape);

    this.options = {};
    this.type = Enums_1.ShapeType.circle;
  }

  _createClass(Shape, [{
    key: "image",
    get: function get() {
      var _a;

      return (_a = this.options[Enums_1.ShapeType.image]) !== null && _a !== void 0 ? _a : this.options[Enums_1.ShapeType.images];
    },
    set: function set(value) {
      this.options[Enums_1.ShapeType.image] = value;
      this.options[Enums_1.ShapeType.images] = value;
    }
  }, {
    key: "custom",
    get: function get() {
      return this.options;
    },
    set: function set(value) {
      this.options = value;
    }
  }, {
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(value) {
      this.image = value;
    }
  }, {
    key: "stroke",
    get: function get() {
      return [];
    },
    set: function set(_value) {}
  }, {
    key: "character",
    get: function get() {
      var _a;

      return (_a = this.options[Enums_1.ShapeType.character]) !== null && _a !== void 0 ? _a : this.options[Enums_1.ShapeType.char];
    },
    set: function set(value) {
      this.options[Enums_1.ShapeType.character] = value;
      this.options[Enums_1.ShapeType.char] = value;
    }
  }, {
    key: "polygon",
    get: function get() {
      var _a;

      return (_a = this.options[Enums_1.ShapeType.polygon]) !== null && _a !== void 0 ? _a : this.options[Enums_1.ShapeType.star];
    },
    set: function set(value) {
      this.options[Enums_1.ShapeType.polygon] = value;
      this.options[Enums_1.ShapeType.star] = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (data === undefined) {
        return;
      }

      var options = (_a = data.options) !== null && _a !== void 0 ? _a : data.custom;

      if (options !== undefined) {
        for (var shape in options) {
          var item = options[shape];

          if (item !== undefined) {
            this.options[shape] = (0, Utils_1.deepExtend)((_b = this.options[shape]) !== null && _b !== void 0 ? _b : {}, item);
          }
        }
      }

      this.loadShape(data.character, Enums_1.ShapeType.character, Enums_1.ShapeType.char, true);
      this.loadShape(data.polygon, Enums_1.ShapeType.polygon, Enums_1.ShapeType.star, false);
      this.loadShape((_c = data.image) !== null && _c !== void 0 ? _c : data.images, Enums_1.ShapeType.image, Enums_1.ShapeType.images, true);

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }, {
    key: "loadShape",
    value: function loadShape(item, mainKey, altKey, altOverride) {
      var _a, _b, _c, _d;

      if (item === undefined) {
        return;
      }

      if (item instanceof Array) {
        if (!(this.options[mainKey] instanceof Array)) {
          this.options[mainKey] = [];

          if (!this.options[altKey] || altOverride) {
            this.options[altKey] = [];
          }
        }

        this.options[mainKey] = (0, Utils_1.deepExtend)((_a = this.options[mainKey]) !== null && _a !== void 0 ? _a : [], item);

        if (!this.options[altKey] || altOverride) {
          this.options[altKey] = (0, Utils_1.deepExtend)((_b = this.options[altKey]) !== null && _b !== void 0 ? _b : [], item);
        }
      } else {
        if (this.options[mainKey] instanceof Array) {
          this.options[mainKey] = {};

          if (!this.options[altKey] || altOverride) {
            this.options[altKey] = {};
          }
        }

        this.options[mainKey] = (0, Utils_1.deepExtend)((_c = this.options[mainKey]) !== null && _c !== void 0 ? _c : {}, item);

        if (!this.options[altKey] || altOverride) {
          this.options[altKey] = (0, Utils_1.deepExtend)((_d = this.options[altKey]) !== null && _d !== void 0 ? _d : {}, item);
        }
      }
    }
  }]);

  return Shape;
}();

exports.Shape = Shape;